import { createFileRoute } from '@tanstack/react-router'
import { requireLoggedIn } from 'sierra-client/core/require-logged-in'
import { NotFoundPage } from 'sierra-client/views/not-found-page'

export const Route = createFileRoute('/404')({
  component: requireLoggedIn(NotFoundPage) as React.FC,
})
